import { useQueryClient } from '@tanstack/react-query'

import { client } from '@/shared/api/client'
import { OptimizationAction, OptimizationStatus } from '@/shared/generated'
import { useOptimizationStatus } from '@/shared/hooks/data'

export function useBeforeGroupChange(optimizationGroupId?: string | null) {
	const queryClient = useQueryClient()
	const status = useOptimizationStatus(optimizationGroupId)
	const onMutate = async () => {
		if (
			optimizationGroupId &&
			status &&
			![
				OptimizationStatus.New,
				OptimizationStatus.Pending,
				OptimizationStatus.Updating,
			].includes(status)
		) {
			await client.optimizations.optimizationAction({
				action: OptimizationAction.Reset,
				optimizationGroupId,
			})
			await queryClient.invalidateQueries({
				queryKey: ['optimization', optimizationGroupId],
			})
			await queryClient.invalidateQueries({
				queryKey: ['optimizations'],
			})
		}
	}

	return {
		onMutate,
	}
}
